module.exports = __webpack_public_path__ + "static/img/3dcartoon1.798018dc.png";